import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, roleHome } from "@/context/AuthContext";

export function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading…</div>;
  if (!user) {
    // Route unauthenticated visitors to the branded portal sign-in that matches the surface they wanted.
    const path = loc.pathname || "";
    let target = "/login";
    if (path.startsWith("/lender")) target = "/lender/login";
    else if (path.startsWith("/refer") || path.startsWith("/introducer")) target = "/introducer/login";
    else target = `/login?next=${encodeURIComponent(path)}`;
    return <Navigate to={target} replace />;
  }
  if (roles && roles.length && !roles.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}
